import { buildCartCategoryScopeOptions } from "./cartCategoryScopes";

export const TEMPLATE_TYPES = [
    { value: "CONTRACT", label: "Contract" },
    { value: "INITIAL_INSPECTION", label: "Initial Inspection" },
    { value: "WORK_ORDER", label: "Work Order" },
    { value: "SUPPLY_ORDER", label: "Supply Order" },
    { value: "GUTTER_ORDER", label: "Gutter Order" }
];

export const AVAILABLE_SCOPES = [
    { value: "Project.Name", label: "Project Name" },

    // Customer
    { value: "Customer.FirstName", label: "Customer First Name" },
    { value: "Customer.LastName", label: "Customer Last Name" },
    { value: "Customer.FullName", label: "Customer Full Name" },
    { value: "Customer.Email", label: "Customer Email" },
    { value: "Customer.Phone", label: "Customer Phone" },
    { value: "Customer.ZipCode", label: "Customer Zip Code" },
    { value: "Customer.Address", label: "Customer Full Address" },

    // Sales Rep
    { value: "SalesRep.FullName", label: "Sales Rep Full Name" },
    { value: "SalesRep.FirstName", label: "Sales Rep First Name" },
    { value: "SalesRep.LastName", label: "Sales Rep Last Name" },
    { value: "SalesRep.Email", label: "Sales Rep Email" },
    { value: "SalesRep.Phone", label: "Sales Rep Phone" },

    // Organization
    { value: "Organization.Name", label: "Organization Name" },
    { value: "Organization.Phone", label: "Organization Phone" },
    { value: "Organization.Email", label: "Organization Email" },
    { value: "Organization.Address", label: "Organization Address" },

    // Dates
    { value: "System.CurrentDate", label: "Current Date" },
    { value: "Contract.Date", label: "Contract Date" },
    { value: "Contract.TotalAmount", label: "Contract Total Amount" },

    // Inspection Scopes
    { value: "Inspection.RoofArea", label: "Roof Area (SQ)" },
    { value: "Inspection.Pitch", label: "Roof Pitch" },
    { value: "Inspection.TearOff", label: "Tear Off Layers" },
    { value: "Inspection.Underlayment", label: "Underlayment Type" },
    { value: "Inspection.IceWaterShield", label: "Ice & Water Shield" },
    { value: "Inspection.Ventilation", label: "Ventilation Scope" },
    { value: "Inspection.ShingleColor", label: "Shingle Color" },
    { value: "Inspection.GutterColor", label: "Gutter Color" },
    { value: "Inspection.DownspoutColor", label: "Downspout Color" },

    // Cart items by product category (Name / Qty / Color)
    ...buildCartCategoryScopeOptions(),

    // Line Items Placeholder (Dynamic Tables)
    { value: "Dynamic.LineItems", label: "Line Items (Table)" },

    // Signatures / Initials
    { value: "Signature.Customer", label: "Customer Signature" },
    { value: "Signature.CustomerInitials", label: "Customer Initials" },
    { value: "Signature.Company", label: "Company Signature" },
    { value: "Signature.Witness", label: "Witness Signature" },
];
